import { adminRpc } from '@/lib/admin-entry'
import { TENANT_ID } from '@/lib/supabase'

export type CustomerActivity = 'access' | 'catalog' | 'cart' | 'checkout' | 'product_details' | 'material'
let observedCustomer: string | null = null
const sent = new Set<string>()

/** Best effort, fixed event names only. Never submit page paths or customer IDs. */
export function recordCustomerActivity(customerId: string | null, event: CustomerActivity) {
  if (customerId !== observedCustomer) { sent.clear(); observedCustomer = customerId }
  if (!customerId) return
  try {
    if (localStorage.getItem('b2b_disable_telemetry') === '1') return
    if (!import.meta.env.PROD && localStorage.getItem('b2b_enable_activity_test') !== '1') return
  } catch { return }
  const key = `${new Date().toLocaleDateString('en-CA', { timeZone: 'America/Fortaleza' })}:${event}`
  if (sent.has(key)) return
  // Bound attempts per mounted browser session as well as daily rows on server.
  if (sent.size >= 24) sent.clear()
  sent.add(key)
  void adminRpc<void>('b2b_record_customer_activity', { p_tenant_id: TENANT_ID, p_event: event }).catch(() => {})
}
